import { firestore } from '../lib/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { getCookie } from "../utils/cookieUtil";
import { Timestamp } from 'firebase/firestore';

export const ExcelExport = async (startDay, endDay) => {

  try {

    const roles = getCookie('roleId');
    const permission = roles ? roles : '';

    let dailyStepQuery;
    if (startDay && endDay) {
      dailyStepQuery = query(
        collection(firestore, 'Daily Steps'),
        where('day', '>=', Number(startDay)),
        where('day', '<=', Number(endDay))
      );
    } else {
      const defaultStartDay = '0';
      const defaultEndDay = '30';
      dailyStepQuery = query(
        collection(firestore, 'Daily Steps'),
        where('day', '>=', Number(defaultStartDay)),
        where('day', '<=', Number(defaultEndDay))
      );
    }

    // Fetch data from Firestore collections
    const userDocs = await getDocs(collection(firestore, 'Users'));
    const goalDocs = await getDocs(collection(firestore, 'Goals'));
    const dailyStepDocs = await getDocs(dailyStepQuery);
    const balanceDocs = await getDocs(collection(firestore, 'Cumulative Balance'));
    const reviewDocs = await getDocs(collection(firestore, 'Review'));
    const freshStartDocs = await getDocs(collection(firestore, 'Fresh Start'));

    const usersData = userDocs.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const goalsData = goalDocs.docs.map(doc => doc.data());
    const dailyStepsData = dailyStepDocs.docs.map(doc => doc.data());
    const balanceData = balanceDocs.docs.map(doc => doc.data());
    const reviewData = reviewDocs.docs.map(doc => doc.data());
    const freshStartData = freshStartDocs.docs.map(doc => ({ ...doc.data(), id: doc.id }));

    // Review mapping
    const reviewMapping = {};
    reviewData.forEach(review => {
      const userId = review.userId;
      const reviewDay = review.day;
      if (!reviewMapping[userId]) reviewMapping[userId] = {};
      reviewMapping[userId][reviewDay] = review;
    });

    // Fresh Start dates mapping
    const freshStartMapping = {};
    freshStartData.forEach(freshStart => {
      const userId = freshStart.id;

      freshStart.dates.forEach(dateEntryMap => {
        Object.values(dateEntryMap).forEach(entry => {
          const dateToProcess = entry instanceof Timestamp ? entry : entry.date;

          if (dateToProcess && typeof dateToProcess.toDate === 'function') {
            const freshStartDate = dateToProcess.toDate().toISOString().split('T')[0];

            if (!freshStartMapping[userId]) freshStartMapping[userId] = [];
            freshStartMapping[userId].push(freshStartDate);
          } else {
            console.warn(`No valid date found in entry for user ${userId}`);
          }
        });
      });
    });

    console.log("Final fresh start dates mapping:", freshStartMapping);

    // Structure data for each user
    const userDataBySheet = {};

    usersData.forEach(user => {
      const userGoals = goalsData.find(goal => goal.uid === user.uid);
      const userDailySteps = dailyStepsData.filter(step => step.userId === user.uid);
      const userBalance = balanceData.find(balance => balance.userId === user.uid);
      const freshStartDates = freshStartMapping[user.id] || [];

      const sheetData = [];
      let serialNumber = 1;

      userDailySteps.forEach(step => {
        const stepDay = step.day;
        const stepDate = step.timestamp.toDate().toISOString().split('T')[0];

        const reviewForDay = reviewMapping[user.uid] ? reviewMapping[user.uid][stepDay] : null;
        const matchingFreshStartDates = freshStartDates.filter(date => date === stepDate);

        const row = {
          SiNo: serialNumber++,
          UserID: user.uid,
          Group: user.group,
          DailyGoal: userGoals ? userGoals.Goal : '',
          GoalDate: userGoals ? userGoals.goalSettingDate.toDate().toISOString().split('T')[0] : '',
          Day: stepDay,
          DayDate: stepDate,
          DailySteps: step.Steps,
          CumulativeBalance: userBalance ? userBalance.balance : '',
          Feedback1: reviewForDay ? reviewForDay.question1 : '',
          Feedback2: reviewForDay ? reviewForDay.question2 : '',
          Feedback3: reviewForDay ? reviewForDay.question3 : '',
          FreshStartDates: matchingFreshStartDates.join(', '),
        };

        // Conditionally add fields based on permission
        if (permission.includes("adduser")) {
          row.Email = user.email;
          row.FirstName = user.name.firstName;
          row.LastName = user.name.secondName;
        }

        sheetData.push(row);
      });

      userDataBySheet[user.uid] = sheetData;
    });

    return userDataBySheet;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw new Error('Failed to fetch data');
  }
};

